export const containsTag = (tagsArray, tagToCheck) => tagsArray.includes(tagToCheck);
